module.exports = __webpack_public_path__ + "img/eCPPT-badge-small.b81f7d89.png";